import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import type { Theme } from "@mui/material/styles";

export interface OperatorInformationSectionProps {
  companyName: string | null;
  accountResponsible: string | null;
  email: string | null;
  phoneNumber: string | null;
}

export const OperatorInformationSection: React.FC<OperatorInformationSectionProps> = ({
  companyName,
  accountResponsible,
  email,
  phoneNumber,
}) => {
  return (
    <Box
      sx={(theme: Theme) => ({
        backgroundColor: theme.palette.grey[100],
        borderRadius: 1,
        p: 2,
        mb: 3,
      })}
    >
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <BusinessIcon fontSize="small" color="action" />
        <Typography variant="subtitle2" fontWeight={600}>
          Operator Information
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
            <BusinessIcon sx={{ fontSize: 16, color: "text.secondary" }} />
            <Typography variant="caption" color="text.secondary">
              Company Name
            </Typography>
          </Box>
          <Typography
            variant="body1"
            fontWeight={500}
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {companyName || "—"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
            <PersonIcon sx={{ fontSize: 16, color: "text.secondary" }} />
            <Typography variant="caption" color="text.secondary">
              Account Responsible
            </Typography>
          </Box>
          <Typography
            variant="body1"
            fontWeight={500}
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {accountResponsible || "—"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
            <EmailIcon sx={{ fontSize: 16, color: "text.secondary" }} />
            <Typography variant="caption" color="text.secondary">
              Email Address
            </Typography>
          </Box>
          <Typography
            variant="body1"
            fontWeight={500}
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {email || "—"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
            <PhoneIcon sx={{ fontSize: 16, color: "text.secondary" }} />
            <Typography variant="caption" color="text.secondary">
              Phone Number
            </Typography>
          </Box>
          <Typography
            variant="body1"
            fontWeight={500}
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {phoneNumber || "—"}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OperatorInformationSection;
